import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { BuilderIoTabsProvider } from './BuilderIoTabsProvider';
import styles from './BuilderIoTavs.module.scss';

export const BuilderIoTabsInputs = [
  {
    name: 'defaultTabId',
    type: 'number',
    helperText: 'Set the tab which will be opened by default. This field should be one of "Tab id" of "Tabs" list.',
    required: true,
  },
  {
    name: 'tabs',
    type: 'list',
    subFields: [
      {
        type: 'string',
        name: 'tabTitle',
        helperText: 'The title which will be visible for tab',
        required: true,
      },
      {
        type: 'number',
        name: 'tabId',
        required: true,
      },
      {
        type: 'string',
        name: 'tabSlug',
        helperText: 'The slug which will be set if tab navigation happens.',
        required: true,
      },
    ],
  },
];
export type BuilderIoTabItem = { tabTitle: string; tabId: number; tabSlug: string };

export type BuilderIoTabsType = {
  tabsSectionId: number;
  defaultTabId: number;
  children: JSX.Element;
  tabs: { tabTitle: string; tabId: number; tabSlug: string }[];
};

export const BuilderIoTabs: FC<BuilderIoTabsType> = ({ children, defaultTabId, tabs }) => {
  const params = useParams();
  const [activeTab, setActiveTab] = useState<number>(defaultTabId);
  const location = useLocation();
  const navigate = useNavigate();

  const handleTabChange = (tab: BuilderIoTabItem): void => {
    const path = location.pathname;

    setActiveTab(tab.tabId);

    if (params.tab) {
      navigate(path.replace(params.tab, tab.tabSlug));
      return;
    }

    if (tab.tabSlug) {
      navigate(path + '/' + tab.tabSlug);
    }
  };

  useEffect(() => {
    if (params.tab) {
      const activeTab = tabs.find((item) => item.tabSlug === params.tab);
      activeTab && setActiveTab(activeTab?.tabId);
    }
  }, []);

  return (
    <BuilderIoTabsProvider value={{ activeTab, setActiveTab }}>
      <div>
        <div className={styles.tabsList}>
          {tabs?.map((tab) => (
            <button
              onClick={() => handleTabChange(tab)}
              key={tab.tabId}
              className={classNames(styles.tab, { [styles.tabActive]: tab.tabId === activeTab })}
            >
              {tab.tabTitle}
            </button>
          ))}
        </div>

        <div>{children.props?.children?.map((child: any) => child)}</div>
      </div>
    </BuilderIoTabsProvider>
  );
};
